<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">


        <div class="title-wrapper">
            <div class="title-com-capa">
                @if (isEditMode && imagemCapaSrc) {
                <img class="produto-imagem-capa" [src]="imagemCapaSrc" [alt]="nomeProdutoTitulo" />
                }
                <div>
                    <h1 class="title-default">{{ isEditMode ? nomeProdutoTitulo : 'Cadastro de Produto' }}</h1>

                    <p class="welcome-message">
                        <button mat-icon-button routerLink="../">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        @if(nomeProdutoPai){
                        Variação de: {{ nomeProdutoPai }} - SKU: {{ skuProdutoPai }}

                        <a mat-button target="_blank"
                            [routerLink]="['/cadastros/produtos/cadastrar', {idProduto: idProdutoPai}]">Acessar
                            produto pai</a>
                        }
                        @else{
                        Gerenciamento de produtos
                        }
                    </p>

                </div>
            </div>
        </div>

        <form [formGroup]="form" (ngSubmit)="salvar()">
            <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

            <app-produto-dados-gerais [form]="form" [isEditMode]="isEditMode" [listaTipoProduto]="listaTipoProduto"
                [listaTipoItemSped]="listaTipoItemSped" [listaUnidadeMedida]="listaUnidadeMedida"
                [listaOrigem]="listaOrigem" [listaEmbalagem]="listaEmbalagem" [urlNcm]="urlNcm"
                [idProdutoPai]="idProdutoPai" [masks]="masks" (tipoProdutoChange)="onTipoProdutoChange($event)"
                [percentageMask]="percentageMask" [isBuscandoGtin]="isBuscandoGtin" [integerMask]="integerMask"
                (buscarGtin)="onBuscarGtin()">
            </app-produto-dados-gerais>

            @if(isKit){
            <app-produto-kits [form]="form" [urlProduto]="urlProduto" [configuracaoProduto]="configuracaoProduto"
                [dadosIniciais]="dadosKitsCarregados" (precoAtualizado)="onPrecoKitAtualizado($event)"
                (pesoAtualizado)="onPesoKitAtualizado($event)" (multiploInvalido)="onMultiploKitInvalido($event)"
                [quantidadeMask]="quantidadeMask" [defaultCurrencyMask]="defaultCurrencyMask">
            </app-produto-kits>
            }

            <app-produto-precos [form]="form" [listaPreco]="listaPreco" [dadosPrecosCarregados]="dadosPrecosCarregados"
                [isKit]="isKit" [idProduto]="idProduto" [totalKitComposicao]="precoKitAtualizado"
                [defaultCurrencyMask]="defaultCurrencyMask" [dynamicCurrencyMask]="dynamicCurrencyMask"
                [percentageMask]="percentageMask" (precoPadraoIdentificado)="onPrecoPadraoIdentificado($event)">
            </app-produto-precos>

            <app-produto-estoque [form]="form" [isKit]="isKit" [isVariacao]="isVariacao" [isEditMode]="isEditMode"
                [listaLocalizacaoEstoque]="listaLocalizacaoEstoque" [dadosEstoqueCarregados]="dadosEstoqueCarregados"
                [quantidadeMask]="estoqueQuantidadeMask" [integerMask]="integerMask"
                [isFracionada]="isFracionadaEstoque">
            </app-produto-estoque>

            <app-produto-complementares [form]="form" [listaCategoria]="listaCategoria" [listaMarca]="listaMarca"
                [anexos]="anexos" (anexosChange)="onAnexosChange($event)">
            </app-produto-complementares>

            <app-produto-atributos [form]="form" [listaAtributo]="listaAtributo"
                [dadosAtributosCarregados]="dadosAtributosCarregados">
            </app-produto-atributos>

            @if(isVariacao){
            <app-produto-variacoes [form]="form" [isVariacao]="isVariacao" [listaVariacao]="listaVariacao"
                [dadosVariacoesProdutoCarregados]="dadosVariacoesProdutoCarregados" [isEditMode]="isEditMode"
                [listaPreco]="listaPreco" [dadosVariacoesCarregados]="dadosVariacoesCarregados"
                [listaLocalizacaoEstoque]="listaLocalizacaoEstoque" [quantidadeMask]="estoqueQuantidadeMask"
                [isFracionada]="isFracionadaEstoque">
            </app-produto-variacoes>
            }

            @if(isFabricado){
            <app-produto-producao [form]="form" [isFabricado]="isFabricado" [urlProduto]="urlProduto"
                [isEditMode]="isEditMode" [dadosEstruturaProducaoCarregados]="dadosEstruturaProducaoCarregados"
                [dadosEtapasProducaoCarregados]="dadosEtapasProducaoCarregados" [quantidadeMask]="quantidadeMask"
                [configuracaoProduto]="configuracaoProduto" (custoAtualizado)="onCustoProducaoAtualizado($event)">
            </app-produto-producao>
            }

            @if(!isVariacao){
            <app-produto-custos [form]="form" [dadosCustosCarregados]="dadosCustosCarregados" [custoMedioAtual]="custoMedioAtual"
                [defaultCurrencyMask]="defaultCurrencyMask"
                [dynamicCurrencyMask]="dynamicCurrencyMask"></app-produto-custos>
            }

            <app-produto-outros [form]="form" [listaLinhaProduto]="listaLinhaProduto" [listaTag]="listaTag"
                [listaUnidadeMedida]="listaUnidadeMedida" [masks]="masks" [urlFornecedor]="urlFornecedor"
                [dadosFornecedoresCarregados]="dadosFornecedoresCarregados" [percentageMask]="percentageMask"
                [defaultCurrencyMask]="defaultCurrencyMask" [dynamicCurrencyMask]="dynamicCurrencyMask"
                [quantidadeMask]="quantidadeMask" [isKit]="isKit">
            </app-produto-outros>

        </form>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving"
    (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>